
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Main_Data_text","data-name":"Main Data text","transform":"translate(-224.5 -605)"}},[_c('g',{attrs:{"id":"Group_29701","data-name":"Group 29701","transform":"translate(122.849 65.849)"}},[_c('rect',{attrs:{"id":"Rectangle_9038","data-name":"Rectangle 9038","width":"14","height":"14","transform":"translate(101.651 539.151)","fill":"none"}}),_c('g',{attrs:{"id":"Group_29713","data-name":"Group 29713","transform":"translate(105 541.575)"}},[_c('g',{attrs:{"id":"b"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"Group_29576","data-name":"Group 29576","fill":"none","stroke":"#96a0ae","stroke-linecap":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"d","d":"M9.4 1.762a1.285 1.285 0 010-.226A1.143 1.143 0 008.18.49H5.75v8.328h2","transform":"translate(-2.102 -.484)"}}),_c('path',{attrs:{"id":"e","d":"M2.132 8.815h2V.481H1.706A1.147 1.147 0 00.481 1.526a1.285 1.285 0 010 .226","transform":"translate(-.481 -.481)"}})])])])])])])])
          )
        }
      }
    